import React, { Fragment } from 'react';
import Clock from './Clock';
import { withTranslations } from 'js/components/hocs/withTranslations';
import {
    DAYS_FIRST_INDEX,
    HOURS_FIRST_INDEX,
    MINUTES_FIRST_INDEX
} from './constants';
import style from './index.scss';

export const Unlimited = withTranslations(({ t }) => (
    <div>
        <div className={style.label}>
            {t('playtech.mobile.system.dp.label.unlimited')}
        </div>
        <div className={style.unlimited}>
            {t('playtech.mobile.system.dp.display.unlimited')}
        </div>
    </div>
));

export default ({
    isUnlimited,
    segments,
    activeIndex,
    useDays,
    useHours,
    useMinutes,
    onSelect,
    isError,
    isErrorPeriods,
    triggerShake
}) => (
    <div className={style.timer}>
        {isUnlimited
            ? <Unlimited />
            : <Fragment>
                {useDays && <Clock onClick={onSelect}
                    firstIndex={DAYS_FIRST_INDEX}
                    activeIndex={activeIndex}
                    segments={segments}
                    type="days"
                    triggerShake={triggerShake}
                    isError={isError}
                    isErrorPeriod={isErrorPeriods[0]}
                />}
                {useDays && useHours && <div className={style.separator}>/</div>}
                {useHours && <Clock onClick={onSelect}
                    firstIndex={HOURS_FIRST_INDEX}
                    activeIndex={activeIndex}
                    segments={segments}
                    type="hours"
                    triggerShake={triggerShake}
                    isError={isError}
                    isErrorPeriod={isErrorPeriods[1]}
                />}
                {useHours && useMinutes && <div className={style.separator}>:</div>}
                {useMinutes && <Clock onClick={onSelect}
                    firstIndex={MINUTES_FIRST_INDEX}
                    activeIndex={activeIndex}
                    segments={segments}
                    type="minutes"
                    triggerShake={triggerShake}
                    isError={isError}
                    isErrorPeriod={isErrorPeriods[2]}
                />}
            </Fragment>
        }
    </div>
);
